import React, { useState, useEffect } from "react";
import { Col, Row } from "reactstrap";
import { TextField } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import { Autocomplete } from "@material-ui/lab";

// Redux
import { connect } from "react-redux";

//Componentes
import CustomModal from "../../../components/modales/customModal";

//API
import { functionsHttpsCallable } from "../../../utils/FirebaseStorage/firebase";
const crearRetiro = functionsHttpsCallable("ape_crearRetiro");

const mapStateToProps = (state) => ({
  usuarioActivo: state,
});

const ModalCreacionRetiro = (props) => {
  const navigate = useNavigate();
  const [userData] = useState(JSON.parse(localStorage.getItem("userData")));
  const [cedulaRetiro, setCedulaRetiro] = useState(undefined);
  const [motivoRetiro, setMotivoRetiro] = useState(undefined);
  const [userId, setUserId] = useState(parseInt(userData.userId));

  useEffect(() => {}, []);

  const handleUpdateCedula = (value) => {
    if (value) setCedulaRetiro(value);
  };

  const handleCrearRetiro = async () => {
    props.setLoading(true);
    try {
      const body = {
        cod_empr: userData.codigoEmpresa,
        cedulaRetiro: cedulaRetiro,
        motivoRetiro: motivoRetiro,
      };
      const crearReq = await crearRetiro(body);
      props.toggle();
      navigate("/home");
      props.toastSuccess("Retiro creado con éxito");
    } catch (error) {
      props.toastError("Hubo un error");
    }

    props.setLoading(false);
  };

  return (
    <React.Fragment>
      <CustomModal
        modal={props.modal}
        toggle={() => props.toggle()}
        title={`Crear Retiro`}
        buttonTitle={"Crear"}
        id={"crear_retiro"}
        onClick={() => {
          handleCrearRetiro();
        }}
      >
        <div>
          <Row className="retiro-area">
            <Col lg="6" md="6" xs="12">
              <TextField
                required
                autoComplete="off"
                key={`key_crear_retiro`}
                id={`input_crear_retiro`}
                fullWidth
                label={`Cedula`}
                value={cedulaRetiro}
                onChange={(e) => {
                  handleUpdateCedula(e.target.value);
                }}
                margin="normal"
              />
            </Col>
            <Col lg="6" md="6" xs="12">
              <Autocomplete
                required
                margin="dense"
                options={[
                  { label: "Renuncia", value: "RENUNCIA" },
                  { label: "Terminacion de labor", value: "TERMINACION_LABOR" },
                  { label: "Abandono de cargo", value: "ABANDONO_CARGO" },
                  {
                    label: "Vencimiento contrato",
                    value: "VENCIMIENTO_CONTRATO",
                  },
                  {
                    label: "Despido sin justa causa",
                    value: "DESPIDO_SIN_JUSTA_CAUSA",
                  },
                  {
                    label: "Despido con justa Causa",
                    value: "DESPIDO_CON_JUSTA_CAUSA",
                  },
                  { label: "Periodo de Prueba", value: "PERIODO_PRUEBA" },
                ]}
                key={`key_Cargo`}
                id={`select_Cargo`}
                onChange={(event, newValue) => {
                  if (newValue) {
                    setMotivoRetiro(newValue.value);
                  } else {
                    setMotivoRetiro(undefined);
                  }
                }}
                renderInput={(params) => (
                  <TextField {...params} label={"Motivo del retiro"} margin="normal" />
                )}
                getOptionLabel={(option) => option.label}
                renderOption={(option) => (
                  <React.Fragment>{option.label}</React.Fragment>
                )}
              />
            </Col>
          </Row>
        </div>
      </CustomModal>
    </React.Fragment>
  );
};

export default connect(mapStateToProps)(ModalCreacionRetiro);
